<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    title="编辑"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    :visible.sync="dialogVisible"
    width="70%"
  >
    <div class="unPb24">
      <el-form ref="baseFromRef" :model="formDataDomain" label-position="top" :rules="formRules">
        <el-row :gutter="20">
          <!-- 高级搜索名称 -->
          <el-col :span="8">
            <el-form-item label="显示名称" label-width="120px" class="padding-right25" prop="searchItemDisplayName">
              <el-input
                v-model="formDataDomain.searchItemDisplayName"
                placeholder="请输入显示名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 高级搜索的key -->
          <!-- <el-col :span="8">
            <el-form-item label="Name" label-width="120px" class="padding-right25">
              <el-input
                v-model="formDataDomain.searchItemName"
                placeholder="(searchItemName)"
              ></el-input>
            </el-form-item>
          </el-col> -->

          <!-- 高级搜索的key -->
          <el-col :span="8">
            <el-form-item
              label="搜索key"
              label-width="120px"
              class="padding-right25"
              prop="searchItemBindingFlag"
            >
              <el-input
                v-model="formDataDomain.searchItemBindingFlag"
                :disabled="!!propData.columnName"
                placeholder="请输入搜索key"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" label-width="120px" class="padding-right25">
              <div style="display: flex; flex-direction: row">
                <div style="flex: 2">
                  <el-select
                    v-model="formDataDomain.searchItemType"
                    placeholder="请选择类型"
                  >
                    <el-option
                      v-for="item in searchTypes"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  v-if="
                    [
                      enumSearchComponentType.select,
                      enumSearchComponentType.selectPage,
                      enumSearchComponentType.treeSelect
                    ].includes(formDataDomain.searchItemType)
                  "
                  style="flex: 1"
                >
                  <el-select
                    v-model="formDataDomain.searchItemDataMultiple"
                    placeholder="请选择是否单搜还是多搜"
                  >
                    <el-option
                      v-for="item in accordingMultiSelect"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <!-- 高级搜索是否为更多项 -->
          <el-col :span="8">
            <el-form-item label="是否默认显示" label-width="120px" class="padding-right25">
              <el-select
                v-model="formDataDomain.moreFlag"
                placeholder="请选择是否默认显示"
              >
                <el-option
                  v-for="item in accordingState"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 高级搜索是否隐藏 -->
          <el-col :span="8">
            <el-form-item
              label="是否可隐藏"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="formDataDomain.hidden"
                placeholder="请选择是否可隐藏"
              >
                <el-option
                  v-for="item in accordingState"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- 高级搜索的类型 -->
        </el-row>
        <!-- 高级搜索是否多选 -->
        <!--<el-col :span="8" v-if="[enumSearchComponentType.select,
            enumSearchComponentType.selectPage,
            enumSearchComponentType.treeSelect].includes(formDataDomain.searchItemType)">
              <el-form-item label="MultiSelect" label-width="120px" class="padding-right25">

              </el-form-item>
            </el-col>-->
        <fieldset
          v-if="
            [
              enumSearchComponentType.select,
              enumSearchComponentType.selectPage,
              enumSearchComponentType.treeSelect
            ].includes(formDataDomain.searchItemType)
          "
        >
          <legend>
            <span>数据服务</span>
            <el-radio-group v-model="formData.componentDataSource" size="mini">
              <el-radio-button label="Dynamic">动态数据</el-radio-button>
              <el-radio-button label="Static">静态固定数据</el-radio-button>
            </el-radio-group>
          </legend>
          <div v-if="formData.componentDataSource === 'Dynamic'">
            <el-row :gutter="20">
              <!-- 高级搜索查询接口 -->
              <el-col :span="24">
                <el-form-item
                  label="服务接口类型"
                  label-width="120px"
                  class="padding-right25"
                >
                  <div style="display: flex">
                    <div style="flex: 2">
                      <el-select  v-model="formData.dataOper" placeholder="请选择接口地址" value-key="searchItemDataUrl" @change="dataoPerChange">
                        <el-option v-for="item in commonDataList" :key="item.searchItemDataUrl"  :label="item.label" :value="item"></el-option>
                      </el-select>
                    </div>
                    <div style="flex: 1">
                      <el-select
                        v-model="formDataDomain.searchItemDataRequestMethod"
                        placeholder="请选择接口请求方式"
                      >
                        <el-option label="未设置" value=""></el-option>
                        <el-option label="GET" value="get"></el-option>
                        <el-option label="POST" value="post"></el-option>
                        <el-option label="PUT" value="put"></el-option>
                        <el-option label="DELETE" value="delete"></el-option>
                      </el-select>
                    </div>
                    <div style="flex: 3">
                      <el-select
                        v-model="formDataDomain.searchItemDataService"
                        placeholder="请选择接口服务名称"
                      >
                        <el-option label="未设置" value=""></el-option>
                        <el-option
                          label="scim-edm-base(基础服务)"
                          value="/scim-edm-base"
                        ></el-option>
                        <el-option
                          label="scim-edm-equipment(设备服务)"
                          value="/scim-edm-equipment"
                        ></el-option>
                        <el-option
                          label="scim-edm-knowledge(知识服务)"
                          value="/scim-edm-knowledge"
                        ></el-option>
                        <el-option
                          label="scim-edm-other(其它服务)"
                          value="/scim-edm-other"
                        ></el-option>
                        <el-option label="admin(系统服务)" value="/admin"></el-option>
                        <el-option
                          label="scim-edm-fileview(文件服务)"
                          value="/scim-edm-fileview"
                        ></el-option>
                        <el-option
                          label="scim-edm-infra(infra服务)"
                          value="/scim-edm-infra"
                        ></el-option>
                        <el-option
                          label="scim-bigdata-app(大数据服务)"
                          value="/scim-bigdata-app"
                        ></el-option>
                      </el-select>
                    </div>
                    <!-- <el-select>
                       <el-option v-for=""></el-option>
                    </el-select> -->
                    <div style="flex: 4">
                      <el-input
                        v-model="formDataDomain.searchItemDataUrl"
                        placeholder="请输入接口路径"
                      ></el-input>
                    </div>
                  </div>
                </el-form-item>
              </el-col>

              <!-- 高级搜索查询接口参数 -->
              <el-col :span="8">
                <el-form-item label="接口参数" label-width="120px" class="padding-right25">
                  <el-input
                    v-model="formDataDomain.searchItemDataParams"
                    placeholder="请输入接口参数"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 高级搜索接口查询方式 -->
              <!--<el-col :span="8">
                    <el-form-item label="API for data source request method" label-width="120px" class="padding-right25">
                      &lt;!&ndash;<el-input v-model="formDataDomain.searchItemDataRequestMethod" placeholder="(searchItemDataRequestMethod)"></el-input>&ndash;&gt;

                    </el-form-item>
                  </el-col>-->

              <!-- 高级搜索显示的接口字段 -->
              <el-col :span="8">
                <el-form-item
                  label="接口返回的label"
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemDataLabel"
                    placeholder="请输入想要关联的label字段"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 高级搜索默认获取接口返回值字段 -->
              <el-col :span="8">
                <el-form-item
                  label="接口返回的value"
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemDataValue"
                    placeholder="请输入想要关联的value字段"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 高级搜索级联接口子集取值字段 -->
              <el-col
                v-if="[enumSearchComponentType.treeSelect].includes(formDataDomain.searchItemType)"
                :span="8"
              >
                <el-form-item
                  label="'children' field name of data source (Tree)"
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemDataChildren"
                    placeholder="(searchItemDataChildren)"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="依赖的组件名称"
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemRelatedComponentName"
                    placeholder="请输入依赖组件name"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="Related API param of this item"
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemRelatedUrlParam"
                    placeholder="(searchItemRelatedUrlParam)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="formData.componentDataSource === 'Static'">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  label="Static data source"
                  label-width="120px"
                  class="padding-right25"
                  style="position: relative; display: block"
                >
                  <div
                    style="
                      font-size: 12px;
                      color: #999;
                      position: absolute;
                      top: -36px;
                      left: 0px;
                      z-index: 1;
                      width: 100%;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    <span style="min-width: 40px; flex: 1; text-align: right">示例:</span>
                    <span class="example">
                      <el-input
                        size="mini"
                        placeholder="示例"
                        value='[{"name":"是","label":"是","value":1},{"name":"否","label":"否","value":0}]'
                      ></el-input>
                    </span>
                  </div>
                  <div>
                    <el-input
                      v-model="formDataDomain.searchItemData"
                      type="textarea"
                      :rows="3"
                      placeholder="(searchItemData)"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <!-- 高级搜索级联接口子集取值字段 -->
              <!-- 高级搜索显示的接口字段 -->
              <el-col :span="8">
                <el-form-item
                  label="Label field name of data source "
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemDataLabel"
                    placeholder="(searchItemDataLabel)"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 高级搜索默认获取接口返回值字段 -->
              <el-col :span="8">
                <el-form-item
                  label="Value field name of data source "
                  label-width="120px"
                  class="padding-right25"
                >
                  <el-input
                    v-model="formDataDomain.searchItemDataValue"
                    placeholder="(searchItemDataValue)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </fieldset>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleDialogVisible">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const defaultSearchSetup = {
  searchItemData: "",
  hidden: true,
  moreFlag: true,
  searchItemDisplayName: "",
  searchItemName: "",
  searchItemBindingFlag: "",
  searchItemType: 1,
  searchItemDataService: "",
  searchItemDataUrl: "",
  searchItemDataParams: "",
  searchItemDataRequestMethod: "",
  searchItemDataLabel: "",
  searchItemDataValue: "",
  searchItemDataChildren: "",
  searchItemDataMultiple: false
};

const enumSearchComponentType = {
  input: 1,
  inputNumber: 2,
  select: 3,
  selectPage: 4,
  treeSelect: 5,
  datePicker: 6,
  datePickerRange: 7,
  numberRange: 8
};
export default {
  name: "SearchConfigAdd",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    },
    searchList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      enumSearchComponentType,
      formKey: new Date().getTime(),
      //   高级搜索是否显示
      accordingState: [
        { dictLabel: "是", dictValue: true },
        { dictLabel: "否", dictValue: false }
      ],
      //   高级搜索是否显示
      accordingMultiSelect: [
        { dictLabel: "多选", dictValue: true },
        { dictLabel: "单选", dictValue: false }
      ],
      //   高级搜索是否显示
      dateRangeLimit: [
        { dictLabel: "区间范围", dictValue: 1 },
        { dictLabel: "上下限值", dictValue: 2 }
      ],
      searchTypes: [
        { dictLabel: "输入框(input)", dictValue: enumSearchComponentType.input },
        { dictLabel: "数字输入框(input-number)", dictValue: enumSearchComponentType.inputNumber },
        { dictLabel: "下拉选择(select)", dictValue: enumSearchComponentType.select },
        { dictLabel: "分页下拉选择(select-page)", dictValue: enumSearchComponentType.selectPage },
        { dictLabel: "树状下拉选择(tree-select)", dictValue: enumSearchComponentType.treeSelect },
        { dictLabel: "日期选择(date-picker)", dictValue: enumSearchComponentType.datePicker },
        { dictLabel: "日期范围(date-picker-range)", dictValue: enumSearchComponentType.datePickerRange },
        { dictLabel: "数字范围(number-range)", dictValue: enumSearchComponentType.numberRange }
      ],
      formDataDomain: {
        searchItemData: "",
        hidden: true,
        moreFlag: true,
        searchItemDisplayName: "",
        searchItemName: "",
        searchItemBindingFlag: "",
        searchItemType: 1,
        searchItemDataService: "",
        searchItemDataUrl: "",
        searchItemDataParams: "",
        searchItemDataRequestMethod: "",
        searchItemDataLabel: "",
        searchItemDataValue: "",
        searchItemDataChildren: "",
        searchItemDataMultiple: false,
        searchItemRelatedComponentName: "",
        searchItemRelatedUrlParam: ""
      },
      formData: {
        componentDataSource: "Dynamic",
        /* formCode: "faultReport-FaultRepair",*/
        formCode: "",
        autoCodeSegments: [],
        dataOper: {
          searchItemDataUrl: "0",
          label: "自定义"
        }
      },
      formRules: {
        searchItemDisplayName: [
          {
            required: true,
            message: `请输入显示名称`,
            trigger: "blur"
          }
        ],
        searchItemBindingFlag: [
          {
            required: true,
            message: `请输入搜索key`,
            trigger: "blur"
          }
        ]
      },
      commonDataList: [
        {
          searchItemDataUrl: "0",
          label: "自定义"
        },
        {
          label: "所属部门",
          searchItemDataRequestMethod: "GET",
          searchItemDataService: "/admin",
          searchItemDataUrl: "/api/v1/organization/{tenantId}",
          searchItemDataParams: "tenantId,{parseToTree:true}",
          searchItemDataLabel: "orgName",
          searchItemDataValue: "id"
        },
        {
          label: "区域位置",
          searchItemDataRequestMethod: "GET",
          searchItemDataService: "/scim-edm-base",
          searchItemDataUrl: "/api/v1/area-info/menu",
          searchItemDataParams: "",
          searchItemDataLabel: "name",
          searchItemDataValue: "id",
          id: 2
        },
        {
          label: "用户列表",
          searchItemDataRequestMethod: "GET",
          searchItemDataService: "/admin",
          searchItemDataUrl: "/api/v1/user/page",
          searchItemDataParams: "",
          searchItemDataLabel: "username",
          searchItemDataValue: "id",
          id: 3
        },
        {
          label: "员工列表",
          searchItemDataRequestMethod: "GET",
          searchItemDataService: "/scim-edm-base",
          searchItemDataUrl: "/api/v1/employee-info/page",
          searchItemDataParams: "",
          searchItemDataLabel: "employeeName,employeeCode",
          searchItemDataValue: "employeeUuid",
          id: 4
        }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    if (this.propData.columnName && this.propData.columnFilterJson) {
      this.formDataDomain = JSON.parse(JSON.stringify(this.propData.columnFilterJson));
      if (this.formDataDomain.searchItemType === 3 && this.formDataDomain.searchItemData) {
        this.formData.componentDataSource = this.propData.columnFilterJson.searchItemData ? "Static" : "Dynamic";
        this.formDataDomain.searchItemData = JSON.stringify(this.formDataDomain.searchItemData);
      }
    }
  },
  methods: {
    handleDialogVisible(data) {
      this.$refs.baseFromRef.validate(valid => {
        if (valid) {
          const isAdd = !this.propData.columnName;
          if (isAdd) {
            const hasItem = this.searchList.some(item => item.columnName === this.formDataDomain.searchItemBindingFlag);
            if (hasItem) {
              this.$message.warning("此搜索列已经存在，请修改");
              return;
            }
          }
          if (this.formDataDomain.searchItemType === 3 && this.formDataDomain.searchItemData) {
            this.formDataDomain.searchItemData = JSON.parse(this.formDataDomain.searchItemData);
          }
          console.log(this.formDataDomain.searchItemData);
          this.$emit("refreshData", this.formDataDomain, isAdd);
          this.dialogVisible = false;
        }
      });
    },
    dataoPerChange(val) {
      if (val.searchItemDataUrl !== "0") {
        this.formDataDomain.searchItemDataRequestMethod = val.searchItemDataRequestMethod;
        this.formDataDomain.searchItemDataService = val.searchItemDataService;
        this.formDataDomain.searchItemDataUrl = val.searchItemDataUrl;
        this.formDataDomain.searchItemDataParams = val.searchItemDataParams;
        this.formDataDomain.searchItemDataLabel = val.searchItemDataLabel;
        this.formDataDomain.searchItemDataValue = val.searchItemDataValue;
      } else {
        this.formDataDomain.searchItemDataRequestMethod = "";
        this.formDataDomain.searchItemDataService = "";
        this.formDataDomain.searchItemDataUrl = "";
        this.formDataDomain.searchItemDataParams = "";
        this.formDataDomain.searchItemDataLabel = "";
        this.formDataDomain.searchItemDataValue = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .el-input-number {
    width: 100%;
  }
  .circle-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d4d9e2;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    text-align: center;
    padding: 0px;
    color: #fff;
    background-color: #c6ccd7;
    border-color: #c6ccd7;
  }
  .is-disabled:hover {
    color: #c6ccd7;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #d4d9e2;
  }
  .circle--primary:hover {
    background-color: #00b259;
    border-color: #00b259;
  }
  .circle--delete:hover {
    background-color: #e60000;
    border-color: #e60000;
  }
  .el-select {
    width: 100%;
  }

  legend {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f9f9f9;
    padding: 10px 18px;
    gap: 10px;
    span{
      font-size: 18px;
      font-weight: bold;
      border-radius: 7px;
    }
  }

  fieldset {
    background-color: #f9f9f9;
    clear: both;
  }
  ::v-deep.el-row{
    padding: 0 20px;
  }

  .example{
    flex: 5;
    ::v-deep input{
      border: 0;
      background-color: #f9f9f9;
      color:#999;
    }
  }
</style>
